import { Header } from '@components/Header';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { useAPI } from '@providers/useAPI';

import { routes } from '@routes';
import { useQuery } from '@tanstack/react-query';
import { teamsKeys } from 'app/queries/teams/teamsKeys';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { createFetchTeamQueryFn } from './api/fetchTeam';
import { MainContent } from './styles/MainContent';
import { TeamInformation } from './TeamInformation';
import { TeamMembersTable } from './TeamMembersTable';

export const AdminTeamDetailsPage = () => {
  const { call } = useAPI();
  const { id } = useParams<{ id: string }>();

  const teamQuery = useQuery({
    queryKey: teamsKeys.adminDetail(id ?? ''),
    queryFn: createFetchTeamQueryFn(call),
    enabled: !!id,
  });
  const team = teamQuery.data;
  const isLoading = teamQuery.isFetching;

  const title = team?.name ? team.name : 'Team';

  return (
    <>
      <Helmet>
        <title>{title} - AutoScript</title>
      </Helmet>
      <Header title={title} backRoute={routes.adminOrganizationDetails.make(team?.organizationId)} />

      <LinearProgressLoader active={isLoading} />
      <MainContent>
        {team ? <TeamInformation team={team} /> : null}
        {team ? <TeamMembersTable team={team} /> : null}
      </MainContent>
    </>
  );
};
